import React from 'react'
import i18next from 'i18next'
import type { UserProfile } from '../../../shared/domain/users/types.no-deps'

type CommentNoticeProps = {
    message: string
}

export function CommentNotice({ message }: CommentNoticeProps) {
    return (
        <div className="AppCore__commentTimeline__CommentNotice">
            <zaptic-icon class="AppCore__commentTimeline__CommentNotice__icon" icon-name="info"></zaptic-icon>
            <div className="AppCore__commentTimeline__CommentNotice__message">{message}</div>
        </div>
    )
}

type CommentAdderNoticeProps = {
    nonCollaboratorProfiles: UserProfile[]
}

export function CommentAdderNotice({ nonCollaboratorProfiles }: CommentAdderNoticeProps) {
    if (!nonCollaboratorProfiles.length) {
        return null
    }

    if (nonCollaboratorProfiles.length === 1) {
        const user = nonCollaboratorProfiles[0].name

        return (
            <div className="AppCore__commentTimeline__CommentAdder__notice">
                <CommentNotice
                    message={i18next.t('appcore:TimelineComment.nonCollaboratorsNotice.commentAdderSingular', { user })}
                />
            </div>
        )
    }

    const andi18nKey =
        nonCollaboratorProfiles.length > 3
            ? 'appcore:common.and3WithOthers'
            : `appcore:common.and${nonCollaboratorProfiles.length}`

    const users = i18next.t(andi18nKey, {
        othersCount: nonCollaboratorProfiles.length - 3,
        ...nonCollaboratorProfiles
            .slice(0, 3)
            .reduce((accum, userProfile, index) => ({ ...accum, [`subject${index + 1}`]: userProfile.name }), {}),
    })

    return (
        <div className="AppCore__commentTimeline__CommentAdder__notice">
            <CommentNotice
                message={i18next.t('appcore:TimelineComment.nonCollaboratorsNotice.commentAdderPlural', { users })}
            />
        </div>
    )
}
